async function getConfiguration(almeApiUtils) {
    let configSettings = {};
    try {
        const almeConfigs = await almeApiUtils.getAlmeConfiguration();
        if (almeConfigs) {
            configSettings = almeConfigs.configurationSettings.reduce((prev, x) => {
                return Object.assign(Object.assign({}, prev), { [x.Key]: x.Value });
            }, {});
        }
    }
    catch (error) {
        console.error(error);
    }
    return configSettings;
}
export default getConfiguration;
